import { FormEvent, useState } from 'react'

import * as api from 'api/api'
import { User } from 'api/types'
import { useAction } from 'lib/hooks'
import { t } from 'lib/i18n'

import { Button, Modal, TextField } from './ui'

export const UserFormModal = ({
  title,
  allowAdmin,
  onClose,
  onCreated,
}: {
  title?: string
  allowAdmin?: boolean
  onClose: () => void
  onCreated: (user: User) => void
}) => {
  const [form, setForm] = useState({ email: '', isAdmin: false, name: '', password: '' })
  const { busy, run } = useAction()
  const heading = title ?? t('مستخدم جديد', 'New user')

  const create = async (event: FormEvent) => {
    event.preventDefault()
    const user = await run(
      'create',
      () => api.createUser({ ...form, email: form.email.trim(), isAdmin: allowAdmin && form.isAdmin, name: form.name.trim() }),
      t('تم إنشاء المستخدم', 'User created')
    )
    if (user) onCreated(user)
  }

  return (
    <Modal title={heading} onClose={onClose}>
      <form className="stack" onSubmit={create}>
        <TextField label={t('الاسم', 'Name')} value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} required />
        <TextField
          label={t('البريد الإلكتروني', 'Email')}
          type="email"
          dir="ltr"
          value={form.email}
          onChange={(event) => setForm({ ...form, email: event.target.value })}
          required
        />
        <TextField
          label={t('كلمة المرور', 'Password')}
          type="password"
          dir="ltr"
          autoComplete="new-password"
          hint={t('8 أحرف على الأقل', 'At least 8 characters')}
          value={form.password}
          onChange={(event) => setForm({ ...form, password: event.target.value })}
          required
        />
        {allowAdmin ? (
          <label className="checkbox">
            <input type="checkbox" checked={form.isAdmin} onChange={(event) => setForm({ ...form, isAdmin: event.target.checked })} />
            {t('مدير نظام', 'Admin')}
          </label>
        ) : null}
        <div className="form-actions">
          <Button onClick={onClose}>{t('إلغاء', 'Cancel')}</Button>
          <Button
            type="submit"
            variant="primary"
            busy={busy === 'create'}
            disabled={!form.name.trim() || !form.email.trim() || form.password.length < 8}
          >
            {t('إنشاء', 'Create')}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
